import { API, graphqlOperation } from 'aws-amplify';

import { updateUserNotification } from './graphql/mutations';

export const markNotificationAsRead = id =>
  API.graphql(graphqlOperation(updateUserNotification, { id, read: true }));
